import { NgModule } from '@angular/core';
import { DynamicComponentDirective } from './dynamic-component.directive';

@NgModule({
  exports: [DynamicComponentDirective],
  declarations: [DynamicComponentDirective],
})
export class DynamicComponentModule {}
